// extracted by mini-css-extract-plugin
module.exports = {"container":"DescriptiveBlockWithOptionalValuesList_container__0OqrZ"};